import { RoleBasedInsights } from '../components/RoleBasedInsights';

export default function RolesPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">Role-Based Insights</h1>
          <p className="text-muted-foreground mt-1">
            Explore features and capabilities across different user roles
          </p>
        </div>
      </div>
      <RoleBasedInsights />
    </div>
  );
}
